export interface IDeveloperDetailsDto {
    devId: string;
    userType: string | null;
}

export class DeveloperDetails implements IDeveloperDetailsDto {
    public devId: string;
    public userType: string | null;

    constructor(devId: string, userType: string | null, description?: string | null) {
        this.userType = userType;
        this.devId = devId;
    }
}